import { render, staticRenderFns } from "./NavisionAndNavixy.vue?vue&type=template&id=42cecde3&scoped=true&"
import script from "./NavisionAndNavixy.vue?vue&type=script&lang=js&"
export * from "./NavisionAndNavixy.vue?vue&type=script&lang=js&"
import style0 from "./NavisionAndNavixy.vue?vue&type=style&index=0&id=42cecde3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cecde3",
  null
  
)

export default component.exports